import { useLanguage } from '../../contexts/LanguageContext';

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1" data-testid="language-selector">
      <button
        onClick={() => setLanguage('pt')}
        className={`w-7 h-5 rounded-sm overflow-hidden border-2 transition-all ${
          language === 'pt' ? 'border-bronze' : 'border-transparent opacity-60 hover:opacity-100'
        }`}
        title="Português"
        aria-label="Português"
        data-testid="lang-pt"
      >
        {/* Brazil Flag */}
        <svg viewBox="0 0 36 24" className="w-full h-full">
          <rect fill="#009B3A" width="36" height="24"/>
          <polygon fill="#FEDF00" points="18,2 34,12 18,22 2,12"/>
          <circle fill="#002776" cx="18" cy="12" r="6"/>
          <path fill="#FFF" d="M10,12 Q18,8 26,12" stroke="#FFF" strokeWidth="1" fill="none"/>
        </svg>
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={`w-7 h-5 rounded-sm overflow-hidden border-2 transition-all ${
          language === 'en' ? 'border-bronze' : 'border-transparent opacity-60 hover:opacity-100'
        }`}
        title="English"
        aria-label="English"
        data-testid="lang-en"
      >
        {/* USA Flag */}
        <svg viewBox="0 0 36 24" className="w-full h-full">
          <rect fill="#BD3D44" width="36" height="24"/>
          <rect fill="#FFF" y="1.85" width="36" height="1.85"/>
          <rect fill="#FFF" y="5.54" width="36" height="1.85"/>
          <rect fill="#FFF" y="9.23" width="36" height="1.85"/>
          <rect fill="#FFF" y="12.92" width="36" height="1.85"/>
          <rect fill="#FFF" y="16.62" width="36" height="1.85"/>
          <rect fill="#FFF" y="20.31" width="36" height="1.85"/>
          <rect fill="#192F5D" width="14.4" height="12.92"/>
        </svg>
      </button>
    </div>
  );
};

export default LanguageSelector;
